import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DatePicker, MuiPickersUtilsProvider, TimePicker } from '@material-ui/pickers';
import dayjs from 'dayjs';
import dayjsUtils from "@date-io/dayjs";
import { MuiThemeProvider } from "@material-ui/core";
import theme from '../../styles/shared/pickerTheme';

import { Dropdown } from '../..';
import hourGlass from '../../assets/imgs/hourglass-green.svg';
import clock from '../../assets/imgs/clock-green.svg';
import calender from '../../assets/imgs/calendar.svg';

import "./RecordSchedulerPanel.scss";

const PICK_DATE = "Pick Date";
const SET_TIME = "Set Time";
const DURATION = "Duration";

const pickers = [
  { icon: calender, title: PICK_DATE },
  { icon: clock, title: SET_TIME },
  { icon: hourGlass, title: DURATION },
];

const getRecordDurations = () => {
  const maxRecordDuration = 180;
  const minRecordDuration = 30;
  const durationDivision = maxRecordDuration / minRecordDuration;
  const durations = [];

  for (let i = 1; i <= durationDivision; i++) { // eslint-disable-line
    durations.push({
      label: minRecordDuration * i,
      value: `${minRecordDuration * i} Min`
    });
  }

  return durations;
}

class RecordSchedulerPanel extends Component { // eslint-disable-line react/prefer-stateless-function
  DEFAULT_DURATIONS = getRecordDurations();

  static propTypes = {
    onDatePick: PropTypes.func,
    onDurationPick: PropTypes.func,
    onTimePick: PropTypes.func
  };

  static defaultProps = {
    onDatePick: () => { },
    onDurationPick: () => { },
    onTimePick: () => { }
  };


  state = {// eslint-disable-line
    shouldDisplayDatePicker: false,
    shouldDisplayTimePicker: false,
    shouldDisplayDurationPicker: false,
    selectedItems: {
      [PICK_DATE]: "",
      [SET_TIME]: "",
      [DURATION]: ""
    }
  }

  shouldComponentUpdate() {
    return true;
  }

  handleClick = title => {
    switch (title) {
      case PICK_DATE:
        this.setState({ shouldDisplayDatePicker: true });
        break;
      case SET_TIME:
        this.setState({ shouldDisplayTimePicker: true });
        break;
      case DURATION:
        this.setState({ shouldDisplayDurationPicker: true })
        break;
    }
  };

  handleDatePick = date => {
    const { onDatePick } = this.props;
    this.setState(prevState => ({
      shouldDisplayDatePicker: false,
      selectedItems: {
        ...prevState.selectedItems,
        [PICK_DATE]: dayjs(date.$d).format("dddd, D/MM")
      }
    }));
    if (onDatePick) {
      onDatePick(dayjs(date.$d).format("dddd, MM/D/YYYY"));
    }
  };

  handleTimePick = time => {
    const { onTimePick } = this.props;
    this.setState(prevState => ({
      shouldDisplayTimePicker: false,
      selectedItems: {
        ...prevState.selectedItems,
        [SET_TIME]: dayjs(time.$d).format("hh:mm a")
      }
    }));
    if (onTimePick) {
      onTimePick(dayjs(time.$d).format("hh:mm a"));
    };
  }

  handleDurationPick = duration => {
    const { onDurationPick } = this.props;
    this.setState(prevState => ({
      selectedItems: {
        ...prevState.selectedItems,
        [DURATION]: duration.value
      }
    }));
    if (onDurationPick) {
      onDurationPick(duration.label);
    };
  };

  handleSave = () => {
    const { onSave } = this.props;
    const { selectedSchedule } = this.state;
    if (onSave) {
      onSave(selectedSchedule)
    };
  };

  render() {
    const { shouldDisplayDatePicker, shouldDisplayTimePicker, shouldDisplayDurationPicker, selectedItems } = this.state;

    return (
      <MuiThemeProvider theme={theme}>
        <MuiPickersUtilsProvider utils={dayjsUtils}>
          <div className="record-scheduler-panel">
            <div className="record-scheduler-panel__pickers">
              {pickers.map(picker =>
                <button
                  key={picker.title}
                  type="button"
                  className="record-scheduler-panel__pickers__single-picker"
                  onClick={() => this.handleClick(picker.title)}
                >
                  <img className="record-scheduler-panel__pickers__single-picker__icon" src={picker.icon} alt="" />
                  <span
                    className="record-scheduler-panel__pickers__single-picker__title"
                    style={{ color: selectedItems[picker.title] ? "white" : "#777" }}
                  >{selectedItems[picker.title] || picker.title}</span>
                  {picker.title === DURATION &&
                    <Dropdown
                      placeholder=""
                      items={this.DEFAULT_DURATIONS}
                      displayedProperty="value"
                      parentShouldRenderList={shouldDisplayDurationPicker}
                      isControlled
                      onSelect={this.handleDurationPick}
                      onOutsideClick={() => this.setState({ shouldDisplayDurationPicker: false })}
                    />}
                </button>
              )}
            </div>
            <DatePicker
              open={shouldDisplayDatePicker}
              format="dddd, D/MM"
              minDate={new Date()}
              autoOk
              onChange={date => this.handleDatePick(date)}
              onClose={() => this.setState({ shouldDisplayDatePicker: false })}
            />
            <TimePicker
              placeholder={SET_TIME}
              open={shouldDisplayTimePicker}
              minDate={new Date()}
              ampm
              onChange={time => this.handleTimePick(time)}
              onClose={() => this.setState({ shouldDisplayTimePicker: false })}
            />
          </div>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
};


export default RecordSchedulerPanel;